import { z } from 'zod'
export const createPatentListResponseSchema = z
  .object({
    data: z.object({
      not_found_patents: z.array(z.string()).nullable(),
    }),
  })
  .transform(({ data }) => {
    return {
      notFoundPatents: data.not_found_patents,
    }
  })

export type CreatePatentListResponse = z.infer<
  typeof createPatentListResponseSchema
>
